export default "<db:listitemmenu>\n\t<div data-id='toggleButton'>&#9776;</div>\n\t<div data-id='items' data-property='children'></div>\n</db:listitemmenu>";